import { useEffect, useMemo, useRef, useState } from "react";
import {
  getOverView,
  updateConfig,
} from "../../../store/slices/OverSlice/overViewSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { set, subDays } from "date-fns";
import { empDetails, subCardsDetails } from "./api";
import { toast } from "react-toastify";
import getFilterCount from "../../../utils/getFilterCount";

const useOverView = () => {
  const state = useSelector((state) => state.overview);
  const [page, setPage] = useState(1);
  const [changedDate, setChangedDate] = useState("");
  const [isLoading, setIsLoading] = useState();
  const [inputData, setInputData] = useState("");
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });

  const scrollRef = useRef(null);
  const states = state?.overViewData;
  let qcData = states?.map((item) => item);
  let photoData = states?.map((item) => item);
  let finalData = states?.map((item) => item);
  let metalData = states?.map((item) => item);
  let ogData = states?.map((item) => item);
  let cvdData = states?.map((item) => item);
  let drumballData = states?.map((item) => item);
  let engravingData = states?.map((item) => item);
  let billingData = states?.map((item) => item);
  let packingData = states?.map((item) => item);
  let deliveryData = states?.map((item) => item);
  const dispatch = useDispatch();

  useEffect(() => {
    if (date) {
      initialCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  function initialCall() {
    const startDate = new Date(date.startDate).toISOString().split("T")[0];
    const endDate = new Date(date.endDate).toISOString().split("T")[0];
    dispatch(
      getOverView({ date: [startDate, endDate], page: page, per_page: 10 }),
    );
    setChangedDate([startDate, endDate]);
    dispatch(updateConfig((state) => (state.date = [startDate, endDate])));
  }

  const handleInputSearch = (e) => {
    setInputData(e);
    dispatch(
      updateConfig((state) => {
        state.search = e;
      }),
    );
  };

  const handleSearch = () => {
    dispatch(updateConfig((state) => (state.overViewData = [])));
    dispatch(
      getOverView({
        search: state?.search,
        date: changedDate,
        page: 1,
        per_page: 10,
      }),
    );
  };

  let dataArray = [
    { data: qcData, key: "qc", title: "QC" },
    { data: metalData, key: "metal_qc", title: "Metal QC" },
    { data: ogData, key: "og_qc", title: "Og QC" },
    { data: finalData, key: "final_qc", title: "Final QC" },
    { data: drumballData, key: "drumball", title: "Drumball" },
    { data: cvdData, key: "cvd_rft", title: "CVD" },
    { data: engravingData, key: "engraving", title: "Engraving" },
    { data: photoData, key: "photo_section", title: "Photo" },
    { data: billingData, key: "printing", title: "Printing" },
    { data: packingData, key: "packing", title: "Packing/Final QC" },
    { data: billingData, key: "billing", title: "Billing" },
    { data: deliveryData, key: "delivery", title: "Delivery" },
  ];

  const handleDateChange = (date) => {
    const startDateUTC = new Date(date.startDate);
    const endDateUTC = new Date(date.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    dispatch(
      updateConfig((state) => {
        state.overViewData = [];
        state.currentPage = 1;
      }),
    );
    dispatch(getOverView({ date: dateArray }));
    setPage(1);
    setChangedDate(dateArray);
    dispatch(
      updateConfig((state) => {
        state.date = changedDate;
        state.currentPage = 1;
      }),
    );
  };
  const handleClearClick = () => {
    setInputData("");
    dispatch(
      updateConfig((state) => {
        state.search = "";
        state.date = [];
        state.filter.itemType = [];
        state.filter.shop = [];
        state.filter.priority = [];
        state.currentPage = 1;
      }),
    );
    initialCall();
    setDate({
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    });
  };

  const handleFilterModal = () => {
    dispatch(updateConfig((state) => (state.filterModal = !state.filterModal)));
  };

  useEffect(() => {
    if (page !== 1) {
      let itemTypesIds = state?.filter?.itemType?.map((values) => values?._id);
      let shopIds = state?.filter?.shop?.map((values) => values?._id);
      let statusIds = state?.filter?.priority?.map((values) => values?.id);
      let supplierIds = state?.filter?.supplier?.map((values) => values?._id);
      dispatch(
        getOverView({
          date: changedDate,
          page: page,
          per_page: 10,
          item_type: itemTypesIds,
          shop: shopIds,
          status: statusIds,
          search: state.search,
          supplier: supplierIds,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const handleLoadMore = () => {
    if (state?.total?.overView !== states?.length) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.overViewStatus]);

  const handleCardView = (item, title) => {
    const titleToSlugMap = {
      QC: "qc",
      "Final QC": "final_qc",
      Photo: "photo_section",
      "Metal QC": "metal_qc",
      "Og QC": "og_qc",
      Drumball: "drumball",
      CVD: "cvd_rft",
      Engraving: "engraving",
      Billing: "billing",
      "Packing/Final QC": "packing",
      Delivery: "delivery",
      Printing: "printing",
    };
    let data = {
      id: item?.id,
      slug: titleToSlugMap[title] || "",
    };
    dispatch(updateConfig((state) => (state.viewModal = !state.viewModal)));
    if (!state.viewModal) {
      empDetails({ data }).then((response) => {
        if (response?.data?.status_code === 200) {
          dispatch(
            updateConfig((state) => (state.empDetails = response?.data?.data)),
          );
        } else {
          toast.error("Cant fetch Details");
        }
      });
    }
  };

  const handleClick = (id) => {
    dispatch(
      updateConfig((state) => (state.viewSubModal = !state.viewSubModal)),
    );
    if (!state?.viewSubModal) {
      subCardsDetails(id).then((response) => {
        if (response?.data?.status_code === 200) {
          dispatch(
            updateConfig(
              (state) => (state.subCardsDetails = response?.data?.data),
            ),
          );
        }
      });
    }
  };
  const searchItems = [
    "Gli number",
    "Qc number",
    "Order number",
    "Invoice number",
    "Invoice date",
    "Invoice amount",
    "Invoice status",
  ];

  const filterCount = useMemo(() => {
    return getFilterCount({
      itemType: state?.filter?.itemType,
      shop: state?.filter?.shop,
      supplier: state?.filter?.supplier,
      priority: state?.filter?.priority,
    });
  }, [
    state?.filter?.itemType,
    state?.filter?.shop,
    state?.filter?.supplier,
    state?.filter?.priority,
  ]);

  return {
    state,
    date,
    states,
    dataArray,
    isLoading,
    scrollRef,
    filterCount,
    totalLength: {
      overView: state?.total?.overView,
    },
    apiStatus: {
      overView: state?.overViewStatus,
    },
    inputData,
    handleInputSearch,
    handleClick,
    handleCardView,
    setIsLoading,
    handleLoadMore,
    handleFilterModal,
    handleSearch,
    handleDateChange,
    handleClearClick,
    searchItems,
  };
};

export default useOverView;
